/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import Info from '@spectrum-icons/workflow/Info';
import ViewList from '@spectrum-icons/workflow/ViewList';
import ClassicGridView from '@spectrum-icons/workflow/ClassicGridView';
import SortOrderDown from '@spectrum-icons/workflow/SortOrderDown';
import Refresh from '@spectrum-icons/workflow/Refresh';
import Folder from '@spectrum-icons/workflow/Folder';
import Document from '@spectrum-icons/workflow/Document';
import { AiOutlineCheckCircle } from 'react-icons/ai';
import moment from 'moment';
import {
  Button,
  TableView,
  TableHeader,
  Column,
  TableBody,
  Row,
  Cell,
  Breadcrumbs,
  Item,
  Link,
  ProgressCircle,
  Flex,
} from '@adobe/react-spectrum';
import { getLocalDateTime } from '../../utils/utils';
import { Page } from '../Forms/DynamicForms/style';
import SideMenu from './SideMenu';

import {
  Title,
  TableBox,
  Path,
  SideBar,
  Main,
  Footer,
  Header,
  CellText,
  NameText,
  FinalMessage,
  TopBar,
  Label,
} from './fileComponentStyle';
import { listChildren } from './fileHelper';

function FileComponent(props) {
  const {
    ims,
    wfObjectCodeAndID,
    assetsFolder,
    workfrontUrl,
    handleSubFolderData,
    rootFolder,
    isTaskComponent,
  } = props;

  const [count, setCount] = useState(10);
  const [rowSelected, setRowSelectedData] = useState();
  const [isFinalSubmit, setFinalSubmit] = useState(false);
  const [isSelected, setSelected] = useState(false);
  const [currentPath, setCurrentPath] = useState('');
  const [breadcrumbsArray, setBreadcrumbsArray] = useState([
    { label: 'Home', id: 'Home' },
  ]);

  const getPath = path => {
    if (path?.parentFolderName) {
      const data = {
        label: path.parentFolderName,
        id: path.parentFolderId,
      };
      const matches = breadcrumbsArray.some(
        element => element.label === data.label,
      );
      if (!matches) {
        setBreadcrumbsArray([...breadcrumbsArray, data]);
      }
      return `${currentPath}/`;
    }
    return '/';
  };

  const handleBreadCrumData = id => {
    if (id === 'Home') {
      handleSubFolderData(rootFolder);
    }
    const index = breadcrumbsArray.findIndex(element => element.id === id);
    setBreadcrumbsArray(breadcrumbsArray.slice(0, index + 1));
    listChildren(
      rowSelected.platformName,
      id,
      wfObjectCodeAndID.objID,
      handleSubFolderData,
    );
  };

  const getPlatformName = data => {
    if (data?.platformName) {
      return `${data.platformName}`;
    }
    return '';
  };

  const handleDateAndTime = data => {
    const date = moment(data).format('DD-MM-YYYY');
    const time = `${moment(data).hour()}:${moment(data).minute()}`;
    return `${date} At ${time}`;
  };

  const handleLoadMore = data => {
    const limit = 10;
    if (count < data.length) setCount(count + limit);
  };

  const handleFinalSubmit = () => {
    setFinalSubmit(!isFinalSubmit);
  };

  const handleSelectionChange = id => {
    if (id) {
      setSelected(true);
      const selectedRow = assetsFolder.find(element => element.ID === id);
      setRowSelectedData(selectedRow);
    } else {
      setSelected(false);
    }
  };

  useEffect(() => {
    if (breadcrumbsArray.length > 1) {
      const data = breadcrumbsArray.map(element => element.label).join('/');
      setCurrentPath(data);
    } else {
      setCurrentPath(`${rowSelected?.name}`);
    }
  }, [breadcrumbsArray, rowSelected]);

  return (
    <>
      {isFinalSubmit ? (
        <Main>
          <Header>
            <Button
              top="20px"
              variant="cta"
              UNSAFE_style={{
                backgroundColor: '#268e6c',
                borderColor: '#268e6c',
                float: 'right',
              }}
            >
              Submitted
              <AiOutlineCheckCircle size="20" style={{ marginLeft: '8px' }} />
            </Button>
          </Header>
          <Flex
            direction="column"
            alignItems="center"
            marginStart="static-size-5000"
          >
            <Label>Project successfully created</Label>
            <Link variant="secondary" isQuiet>
              <a href="#/">
                <Button variant="primary">Go to project page</Button>
              </a>
            </Link>
          </Flex>
        </Main>
      ) : (
        <>
          <Main>
            <Header isTaskComponent={isTaskComponent}>
              {isTaskComponent ? (
                ''
              ) : (
                <TopBar>
                  <Title>Start a Project</Title>
                  <span style={{ float: 'right' }}>
                    <Button
                      top="15px"
                      variant="cta"
                      onPress={handleFinalSubmit}
                    >
                      Submit
                    </Button>
                  </span>
                </TopBar>
              )}
              <div>
                <Title>Assets</Title>
              </div>
              <Path>
                <Breadcrumbs
                  onAction={id => {
                    handleBreadCrumData(id);
                  }}
                >
                  {breadcrumbsArray?.length > 0 &&
                    breadcrumbsArray.map(f => (
                      <Item key={f.id}>{f.label}</Item>
                    ))}
                </Breadcrumbs>
              </Path>
            </Header>
            {assetsFolder ? (
              <TableBox isTaskComponent={isTaskComponent}>
                <TableView
                  aria-label="Example table for column alignment"
                  selectionMode="single"
                  density="spacious"
                  onSelectionChange={val => handleSelectionChange(...val)}
                >
                  <TableHeader>
                    <Column align="start">Name</Column>
                    <Column>Platform</Column>
                    <Column>Path</Column>
                    <Column>Last Modified Date</Column>
                  </TableHeader>
                  <TableBody
                    loadingState
                    items={assetsFolder?.slice(0, count) || []}
                  >
                    {item => (
                      <Row key={item?.ID}>
                        <Cell>
                          <div>
                            {item?.isFileIcon ? (
                              <Document size="XS" />
                            ) : (
                              <Folder size="XS" />
                            )}
                            <NameText>
                              <Link
                                onPress={() => {
                                  listChildren(
                                    item.platformName,
                                    item.ID,
                                    wfObjectCodeAndID.objID,
                                    handleSubFolderData,
                                    item.name,
                                    ims,
                                    currentPath,
                                    item.workfrontEndpoint,
                                  );
                                  setSelected(false);
                                }}
                                isQuiet
                                variant="secondary"
                              >
                                {item?.name || ''}
                              </Link>
                            </NameText>
                          </div>
                        </Cell>
                        <Cell>
                          <CellText>{getPlatformName(item)}</CellText>
                        </Cell>
                        <Cell>
                          <CellText>{getPath(item)}</CellText>
                        </Cell>
                        <Cell>
                          <CellText>
                            {item?.lastModDate
                              ? handleDateAndTime(
                                  getLocalDateTime(item.lastModDate),
                                )
                              : 'NA'}
                          </CellText>
                        </Cell>
                      </Row>
                    )}
                  </TableBody>
                </TableView>
                {assetsFolder?.length > count ? (
                  <Button
                    marginTop="30px"
                    variant="primary"
                    onPress={() => handleLoadMore(assetsFolder)}
                  >
                    View more
                  </Button>
                ) : (
                  ''
                )}
              </TableBox>
            ) : (
              <Flex
                justifyContent="space-around"
                minWidth="776px"
                minHeight="420px"
              >
                <ProgressCircle aria-label="loading" isIndeterminate size="L" />
              </Flex>
            )}
            <SideBar>
              <SideMenu
                ims={ims}
                wfObjectCodeAndID={wfObjectCodeAndID}
                isSelected={isSelected}
                rowSelected={rowSelected}
                handleSubFolderData={handleSubFolderData}
                currentPath={currentPath}
              />
            </SideBar>
            <Footer isTaskComponent={isTaskComponent}>
              <div className="footerIcon">
                <ViewList size="S" />
              </div>
              <div className="footerIcon">
                <ClassicGridView size="S" />
              </div>
              <div className="footerIcon">
                <SortOrderDown size="S" />
              </div>
              <div className="footerIconRight">
                <Refresh size="S" />
              </div>
              <div className="footerIcon">
                <Info size="S" />
              </div>
            </Footer>
          </Main>
          {isTaskComponent ? '' : <Page>Page 3 of 3</Page>}
        </>
      )}
    </>
  );
}

export default FileComponent;
